// services/relaxation/getRelaxation.js
import axiosInstance from "services/axiosMiddleware";

export async function getRelaxations({ courseid, studentid }) {
  try {
    const response = await axiosInstance.post('relaxation/relaxation', { courseid, studentid });
    return response.data;
  } catch (error) {
    console.error('Error fetching Relaxation data:', error);
    throw error;
  }
}
